import { Card } from '@xing-com/card';
import {
  SkeletonProfileImage,
  SkeletonHeadline,
  SkeletonBody,
} from '@xing-com/skeleton';

import { Styled } from './article-card-skeleton.styles';

export const ArticleCardSkeleton: React.FC = () => (
  <Card padding="none">
    <Styled.ArticleHeaderSkeleton>
      <SkeletonProfileImage size="xxsmall" />
      <Styled.SkeletonBodyCopy amountRows={1} />
    </Styled.ArticleHeaderSkeleton>
    <Styled.SkeletonImage />
    <Styled.ArticleFooter>
      <SkeletonHeadline size="small" amountRows={1} />
      <SkeletonBody />
    </Styled.ArticleFooter>
  </Card>
);
